import { EmailTemplate } from '../../types';

enum USCCORPIncorporationTaskGroups {
  COMPANY_FORMATION_DETAILS = 'COMPANY_FORMATION_DETAILS',
  INCORPORATION_FILING = 'INCORPORATION_FILING',
  EIN_PROOF = 'PROCURING_EIN_PROOF',
  EIN_LETTER = 'EIN_LETTER',
  ADOPT_BYLAWS = 'ADOPT_BYLAWS',
  BANK_ACCOUNT_CREATION = 'BANK_ACCOUNT_CREATION',
  SHARE_PURCHASE_AGREEMENT = 'SHARE_PURCHASE_AGREEMENT',
  BOI_FILING = 'BOI_FILING',
}

export enum USCCORPIncorporationTasks {
  FILL_CORPORATION_DETAILS = 'FILL_CORPORATION_DETAILS',
  REVIEW_CORPORATION_DETAILS = 'REVIEW_CORPORATION_DETAILS',
  FILE_INCORPORATION = 'FILE_INCORPORATION',
  UPLOAD_INCORPORATION_DOCUMENTS = 'UPLOAD_INCORPORATION_DOCUMENTS',
  FILL_INCORPORATION_DETAILS = 'FILL_INCORPORATION_DETAILS',
  SEND_EMAIL_UPDATE = 'SEND_EMAIL_UPDATE',
  UPLOAD_EIN_PROOF = 'UPLOAD_EIN_PROOF',
  UPLOAD_EIN_LETTER = 'UPLOAD_EIN_LETTER',
  SEND_BYLAWS_FOR_REVIEW = 'SEND_BYLAWS_FOR_REVIEW',
  UPLOAD_SIGNED_BYLAWS = 'UPLOAD_SIGNED_BYLAWS',
  CLIENT_ADD_BANK_ACCOUNT = 'CLIENT_ADD_BANK_ACCOUNT',
  CLIENT_UPLOAD_BANK_WIRE_INSTRUCTIONS = 'CLIENT_UPLOAD_BANK_WIRE_INSTRUCTIONS',
  CLIENT_REVIEWS_SHARE_PURCHASE_INSTRUCTIONS = 'CLIENT_REVIEWS_SHARE_PURCHASE_INSTRUCTIONS',
  CLIENT_UPLOADS_BANK_STATEMENTS = 'CLIENT_UPLOADS_BANK_STATEMENTS',
  VERIFY_BANK_STATEMENTS = 'VERIFY_BANK_STATEMENTS',
  UPLOAD_SHAREHOLDING_DOCUMENTS = 'UPLOAD_SHAREHOLDING_DOCUMENTS',
  CLIENT_UPLOADS_SIGNED_SHAREHOLDING_DOCUMENTS = 'CLIENT_UPLOADS_SIGNED_SHAREHOLDING_DOCUMENTS',
  VERIFY_SIGNED_DOCUMENTS = 'VERIFY_SIGNED_DOCUMENTS',
  BOI_FILING_ACKNOWLEDGEMENT = 'BOI_FILING_ACKNOWLEDGEMENT',
}

export const US_CCORP_TASK_GROUP_TO_EMAIL_MAP: Record<
  USCCORPIncorporationTaskGroups,
  EmailTemplate | null
> = {
  [USCCORPIncorporationTaskGroups.COMPANY_FORMATION_DETAILS]: null,
  [USCCORPIncorporationTaskGroups.INCORPORATION_FILING]: {
    body: `Hi,

Your initial incorporation documents are ready and you can find them in the documents tab of your dashboard.

Your EIN application is in progress.

Warm Regards

Commenda Team`,
    subject: 'Update on filing status with Commenda',
  },
  [USCCORPIncorporationTaskGroups.EIN_PROOF]: {
    body: `Hi,

Your EIN has been issued and the screenshot is available on the Commenda dashboard.

The letter will be uploaded to the dashboard upon arrival.

The next step is to get a bank account. Sharing collaterals on Mercury, Brex, and Truly that you can look at for US banking-

Mercury - https://mercury.com/partner/commenda

Brex - [https://www.brex.com/lp/startups-lw1?partnerId=commenda](https://www.brex.com/lp/startups-lw1?partnerId=commenda%5C)

Truly - https://trulyfinancial.com/?ref=njlhzjk

Warm Regards

Commenda Team`,
    subject: 'Update on EIN status with Commenda',
  },
  [USCCORPIncorporationTaskGroups.EIN_LETTER]: {
    body: `Hi,

Your EIN letter has been uploaded to the Commenda dashboard.

The next step is to get a bank account. Sharing collaterals on Mercury, Brex, and Truly that you can look at for US banking-

Mercury - https://mercury.com/partner/commenda

Brex - [https://www.brex.com/lp/startups-lw1?partnerId=commenda](https://www.brex.com/lp/startups-lw1?partnerId=commenda%5C)

Truly - https://trulyfinancial.com/?ref=njlhzjk

Warm Regards

Commenda Team`,
    subject: 'Update on EIN status with Commenda',
  },
  [USCCORPIncorporationTaskGroups.ADOPT_BYLAWS]: null,
  [USCCORPIncorporationTaskGroups.BANK_ACCOUNT_CREATION]: null,
  [USCCORPIncorporationTaskGroups.SHARE_PURCHASE_AGREEMENT]: null,
  [USCCORPIncorporationTaskGroups.BOI_FILING]: null,
};
